// extracted by mini-css-extract-plugin
module.exports = {"root":"Open_root__1cGCv","bold":"Open_bold__3z0TN","green":"Open_green__2vPyw"};